function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Paikkatietoikkunan vanhojen ilmakuvien esittämiseen GFI-vastauksen muotoiluun tehty koodi.
 * Tason GFI-vastauksen oletetaan olevan Stringinä annettua GeoJSON:ia, josta haetaan
 * kaikista kohteista se, jolla on viimeisin vuosi.
 * 
 * - muotoilun käyttöönotto tasolle: layer.attributes.PTI_GFI_formatter = "latestPhotoYear"
 * - muotoilussa haettavan ominaisuustiedon nimi: layer.attributes.PTI_GFI_property = "[ominaisuustietokentän nimi]", määrittelemättömänä "kuvausvuosi"
 * - käyttäjälle näytettävä teksti: layer.attributes.PTI_GFI_label (voi olla string tai locale object, määrittelemättömänä "Vuosi")
 * 
 * Esim attributes kenttään: 
 * {
    "PTI_GFI_formatter": "latestPhotoYear",
    "PTI_GFI_property": "kuvausvuosi",
    "PTI_GFI_label": {
        "fi": "Vuosi",
        "en": "Year"
    }
   }
 * 
 * Käyttöönotto esim. applications alla index.js:ssä:
 * 
 *     import { PTIOrtophotoTimeseriesGFIformatter } from '../../util/PTIOrtophotoTimeseriesGFIformatter';
 *
 * Oskari.app.startApplication() callbackissä:
 * 
 *     sandbox.findRegisteredModuleInstance('MainMapModuleGetInfoPlugin').addLayerFormatter(new PTIOrtophotoTimeseriesGFIformatter());
 */
export var PTIOrtophotoTimeseriesGFIformatter = /*#__PURE__*/function () {
  function PTIOrtophotoTimeseriesGFIformatter() {
    _classCallCheck(this, PTIOrtophotoTimeseriesGFIformatter);
  }
  return _createClass(PTIOrtophotoTimeseriesGFIformatter, [{
    key: "enabled",
    value: function enabled() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var layerAttributes = this.getLayerAttributes(data.layerId);
      return layerAttributes.PTI_GFI_formatter === "latestPhotoYear";
    }
  }, {
    key: "format",
    value: function format() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var layerAttributes = this.getLayerAttributes(data.layerId);
      try {
        var geojson = JSON.parse(data.content);
        var photoYearAttr = layerAttributes.PTI_GFI_property || 'kuvausvuosi';
        var label = Oskari.getLocalized(layerAttributes.PTI_GFI_label || 'Vuosi');
        var years = geojson.features.map(function (feature) {
          return parseInt(feature.properties[photoYearAttr], 10);
        });
        var year = years.length ? Math.max.apply(Math, _toConsumableArray(years)) : '-';
        return "<b>".concat(label, ":</b> ").concat(year);
      } catch (err) {
        Oskari.log('PTIOrtophotoTimeseriesGFIformatter').warn("Couldn't format GFI data", data);
      }
    }
  }, {
    key: "getLayerAttributes",
    value: function getLayerAttributes(id) {
      var layer = Oskari.getSandbox().getService('Oskari.mapframework.service.MapLayerService').findMapLayer(id);
      if (!layer) {
        return {};
      }
      return layer.getAttributes() || {};
    }
  }]);
}();
;